import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import React from 'react';
import { mediaQueries } from '../css';
import Button from '../UI/Button/Button';
import Icon from '../UI/Icon/Icon';

const Container = styled('div')({
    display: 'flex',
    alignItems: 'start',
    color: 'black',
    paddingTop: '1rem',
    flexDirection: 'column',
    [mediaQueries.medium]: {
        paddingTop: '0',
    },
    [mediaQueries.large]: {
        flexDirection: 'row',
    },
});

const Ul = styled('ul')({
    listStyleType: 'none',
    margin: 0,
    marginBottom: '20px',
    [mediaQueries.large]: {
        marginLeft: '3.125rem',
    },
});

const Li = styled('li')({
    lineHeight: 1.3,
});

const LiTitle = styled('li')({
    lineHeight: 1.3,
    fontSize: '1.25rem',
    fontWeight: 'bold',
});

const Contact = ({ title, name, mail, phoneNumber, link, buttonLabel }) => {
    return (
        <Container>
            {(name || mail || phoneNumber) && (
                <Ul>
                    <LiTitle>{title}</LiTitle>
                    {name && <Li>{name}</Li>}
                    {mail && <Li>{mail}</Li>}
                    {phoneNumber && <Li>{phoneNumber}</Li>}
                </Ul>
            )}

            {link && (
                <Button
                    isLink
                    isTextBlack
                    href={link}
                    className="next-button--presse"
                    icon={<Icon size="small" color="black" name="arte-download-round" />}
                    label={buttonLabel}
                    style={{
                        [mediaQueries.large]: {
                            marginLeft: '3.125rem',
                        },
                    }}
                    target="_blank"
                />
            )}
        </Container>
    );
};

export const propTypes = {
    title: PropTypes.string,
    name: PropTypes.string,
    mail: PropTypes.string,
    phoneNumber: PropTypes.string,
    link: PropTypes.string,
    buttonLabel: PropTypes.string,
};

Contact.propTypes = propTypes;

Contact.defaultProps = {
    title: 'Pressekontakt:',
    buttonLabel: 'Pressemappe',
};

export default Contact;
